"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPatron = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Creates a new patron.
 *
 * ## Usage
 *
 * ```ts
 * const patron: Omit<Patron, '_id'> = {
 *  memberId: "6547839284576",
 * 	tier: "4",
 * 	username: null,
 * 	avatar: null,
 * };
 *
 * const {
 * 	acknowledged,
 * 	insertedId,
 * } = await sdk.createPatron({ patron });
 * ```
 *
 * @param params.patron - Data of the new patron.
 */
const createPatron = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { patron } = params;
    const url = `${BASE_URL}/patrons`;
    const response = yield axios_1.default.post(url, patron, { validateStatus: () => true });
    const { status, data } = response;
    if (status !== 201)
        throw new Error(data.error);
    return data;
});
exports.createPatron = createPatron;
